export default __webpack_public_path__ + "static/media/open-lock.33ec4340.svg";